<template>
  <div class="sr-checkout-form">
    <form id="payment-form" @submit.prevent="handleSubmit">
      <div id="payment-element" />
      <button
        class="button custom-button purchase-button"
        id="submit"
        :disabled="isLoading"
        style="display: none"
      >
        {{ $t("checkout.confirm_payment") }}
      </button>
    </form>
    <div class="card-error" v-if="cardError">{{ this.cardError }}</div>
  </div>
</template>
<style scoped>
.sr-checkout-form form > * {
  margin: 10px 0;
}
</style>
<script>
"use strict";
import { createStripePaymentData } from "@/helper/index.js";
const endpoints = require("@/api/endpoints");
import { get_redirect_url_map, get_redirect_urls } from "@/helper/redirectUrls";

export default {
  name: "SrCheckoutForm",
  data() {
    return {
      elements: null,
      isLoading: false,
      cardError: null,
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale || "en";
    },
  },
  async mounted() {
    console.log("SrCheckoutForm mounted");
    let product_id = this.$route.query.product_id;
    let product_type = this.$route.query.product_type
      ? parseInt(this.$route.query.product_type)
      : 0;

    console.log("Creating Stripe elements with:", { product_id, product_type });
    this.createStripeElements(product_id, product_type, 1);
  },
  methods: {
    async handleSubmit() {
      console.log("SrCheckoutForm handleSubmit called");
      if (this.isLoading == true) {
        console.log("Already loading, returning");
        return;
      }
      if (!this.elements) {
        console.log("No elements found, returning");
        return;
      }

      console.log("Starting Stripe payment confirmation");
      this.isLoading = true;

      // Element'in hala mount olup olmadığını kontrol et
      const elementContainer = document.getElementById("payment-element");
      if (!elementContainer) {
        console.error("Payment element container not found during submit!");
        this.cardError = this.$t("checkout.payment_form_unavailable");
        this.isLoading = false;
        return;
      }

      const thisElements = this.elements;
      const return_url = this.makeReturnUrl();

      try {
        const { error, paymentIntent } = await this.$stripe.confirmPayment({
          elements: thisElements,
          confirmParams: {
            return_url: return_url,
          },
        });

        await this.handlePaymentResult(error, paymentIntent);
      } catch (stripeError) {
        console.error("Stripe confirmPayment error:", stripeError);
        this.cardError = this.$t("checkout.payment_confirmation_failed");
        this.isLoading = false;
        this.redirectToFailedUrl();
      }
    },

    async handlePaymentResult(error, paymentIntent) {
      if (error) {
        if (error.message) {
          this.cardError = error.message;
        } else {
          this.cardError = this.$t("errors.general_error");
        }
        this.isLoading = false;

        // Hata durumunda failed redirect URL'e yönlendir
        this.redirectToFailedUrl();
      } else {
        // Ödeme başarılı - parent component'e haber ver
        // Payment method bilgilerini al
        let lastFour = "1234";
        if (paymentIntent && paymentIntent.payment_method) {
          // Payment method bilgilerini al
          const pm = await this.$stripe.retrievePaymentMethod(
            paymentIntent.payment_method
          );
          if (pm.paymentMethod && pm.paymentMethod.card) {
            lastFour = pm.paymentMethod.card.last4;
          }
        }

        this.$emit("payment-success", {
          paymentMethod: "Card",
          lastFour: lastFour,
        });
      }
    },
    createStripeElements(product_id, product_type, try_count) {
      console.log("createStripeElements called with:", {
        product_id,
        product_type,
        try_count,
      });
      if (try_count < 0) {
        console.log("Try count exhausted");
        return;
      }

      console.log("Calling create_stripe_payment endpoint");

      // Email bilgisini parent component'ten al
      const email =
        this.$parent.userEmailFromUrl || this.$parent.userInfo?.email;
      const paymentData = createStripePaymentData(
        product_type,
        product_id,
        null,
        null
      );
      if (email) {
        paymentData.email = email;
      }

      endpoints
        .create_stripe_payment(this.$axios, paymentData)
        .then((createStripePaymentResponse) => {
          console.log(
            "Stripe payment response:",
            createStripePaymentResponse.data
          );
          if (createStripePaymentResponse.data.error) {
            const code = createStripePaymentResponse.data.error.code;
            console.log("Stripe error code:", code);

            if (code == 1009) {
              // StripeIdempotencyError
              console.log("Idempotency error, retrying...");
              sessionStorage.removeItem("uuid_stripe_payment");
              this.createStripeElements(
                product_id,
                product_type,
                try_count - 1
              );
            }
          } else {
            const clientSecret = createStripePaymentResponse.data.client_secret;
            console.log("Got client secret, creating elements");

            this.elements = this.$stripe.elements({
              clientSecret,
              locale: this.currentLocale,
              appearance: {
                theme: "stripe",
              },
            });

            // Payment Element'i Apple Pay ve Google Pay ile birlikte oluştur
            const paymentElement = this.elements.create("payment", {
              wallets: {
                applePay: "auto",
                googlePay: "auto",
              },
            });

            // Element'in mount edilmesini bekle
            setTimeout(() => {
              const elementContainer =
                document.getElementById("payment-element");
              console.log("Payment element container:", elementContainer);

              if (elementContainer) {
                paymentElement.mount("#payment-element");
                this.isLoading = false;
                console.log("Stripe elements created and mounted successfully");
              } else {
                console.error("Payment element container not found!");
                this.cardError = this.$t("checkout.payment_form_load_error");
              }
            }, 100);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log("stripe error", err);
          this.cardError = this.$t("errors.general_error");
          this.$hybridapi("close", "close");
        });
    },
    makeReturnUrl() {
      // Aynı sayfaya yönlendir ama success parametresi ile
      var url = new URL(window.location.href);
      url.searchParams.set("payment_success", "true");
      // Kart numarası için placeholder - gerçek değer handleSubmit'te eklenir
      url.searchParams.set("last_four", "1234");
      return url.toString();
    },
    redirectToFailedUrl() {
      // Failed redirect URL'e yönlendir
      let [success_redirect_url, failed_redirect_url] = get_redirect_urls();

      // Eğer URL'de yoksa, sessionStorage'dan geri yükle (Safari için)
      if (!success_redirect_url && !failed_redirect_url) {
        try {
          const savedParams = sessionStorage.getItem("stripe_redirect_params");
          if (savedParams) {
            const parsedParams = JSON.parse(savedParams);
            success_redirect_url = parsedParams.success_redirect_url;
            failed_redirect_url = parsedParams.failed_redirect_url;
          }
        } catch (error) {
          console.error("sessionStorage error:", error);
        }
      }

      if (failed_redirect_url) {
        try {
          const url_to_go = new URL(failed_redirect_url);

          // sessionStorage'ı temizle
          sessionStorage.removeItem("stripe_redirect_params");

          window.location.replace(url_to_go);
        } catch (error) {
          console.error("invalid redirect url", error);
        }
      }
    },
  },
};
</script>
